module.exports = __webpack_public_path__ + "static/media/productores.f62af6fc.mp4";